export enum BaseDataRoutes {
  'Sources' = 'sources',
  'CustomFields' = 'custom-fields',
}
